import Birch1 from '../Tipe 6/Tipe 6 (1).webp'
import Birch2 from '../Tipe 6/Tipe 6 (2).webp'
import Birch3 from '../Tipe 6/Tipe 6 (3).webp'
import Birch4 from '../Tipe 6/Tipe 6 (4).webp'
import Birch5 from '../Tipe 6/Tipe 6 (5).webp'
import Birch6 from '../Tipe 6/Tipe 6 (6).webp'
import Birch7 from '../Tipe 6/Tipe 6 (7).webp'
import Birch8 from '../Tipe 6/Tipe 6 (8).webp'
import Birch9 from '../Tipe 6/Tipe 6 (9).webp'


const Birchimages =[
Birch1,Birch2,Birch3,Birch4,Birch5,Birch6,Birch7,Birch8,Birch9
]

export default Birchimages;